import './tags.css';
export function Tag({ kind = 'status', color, children }) {
  return <span data-ds="Tag" data-kind={kind} className="ds-tag" style={color ? { '--tag-color': color } : undefined}>{children}</span>;
}
export function SectionLabel({ bracket = false, children }) {
  return <span className="ds-section-label" data-bracket={bracket || undefined}>{bracket ? <>[ {children} ]</> : children}</span>;
}

export function StatusLabel({ status, variant = 'badge', icon, children, style, ...props }) {
  const value = String(status || '').toLowerCase();
  const tone = /fail|error/.test(value) ? 'error' : /outdated/.test(value) ? 'warning' : /running|processing|uploading/.test(value) ? 'accent' : /done|ready|saved|complete|success|approved|production|^active$|in assets/.test(value) ? 'success' : 'muted';
  return <span {...props} data-ds="StatusLabel" data-variant={variant} data-state={value} data-tone={tone} className="ds-status-label" style={style}>{icon || <span className="ds-status-dot" aria-hidden="true" />}<span>{children || status}</span></span>;
}
